import React, { useEffect, useState } from "react";
import { IoMdSend } from "react-icons/io";
import { useDispatch } from "react-redux";
import {
  createComeBackDoctorAction,
  updateComeBackDoctorAction,
} from "../../Actions/AffiarsSurgeryAction/ComeBackDoctor";

const ComeBackFromDoctor = ({
  branchId,
  visitId,
  patientId,
  comeBackDoctor,
}) => {
  const [note, setNote] = useState(null);
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  useEffect(() => {}, [comeBackDoctor]);
  const handleSubmit = (e) => {
    e.preventDefault();
    if (note == null || note == "") {
      setError("Please Fill This Gap");
      return;
    } else {
      if (comeBackDoctor) {
        dispatch(
          updateComeBackDoctorAction(
            comeBackDoctor.id,
            note,
            visitId,
            branchId,
            patientId
          )
        );
      } else {
        dispatch(
          createComeBackDoctorAction(note, visitId, branchId, patientId)
        );
      }
    }
  };
  //   setNote(comeBackDoctor.note)
  useEffect(() => {
    if (comeBackDoctor) {
      setNote(comeBackDoctor.note);
    } else {
        setNote(null)
    //   return;
    }
  }, [comeBackDoctor]);
  return (
    <div>
      <div className="bg-teal-500 md:w-5/12 lg:w-2/12 m-auto text-white text-center mt-2 p-2">
        گەڕانەوە لای دکتۆر
      </div>
      <form action="">
        <div>
          <textarea
            name=""
            className="input w-full mt-1"
            placeholder="note"
            id=""
            onChange={(e) => setNote(e.target.value)}
            value={note || ""}
          ></textarea>

          <p className="text-red-500">{error}</p>
        </div>
        <button
          onClick={handleSubmit}
          className="btn-info flex gap-2 items-center"
        >
          Send <IoMdSend />
        </button>
      </form>
    </div>
  );
};

export default ComeBackFromDoctor;
